
<section class="limit-section">
  <!-- titre + description spécifique à la catégorie -->
  <!-- panels Jour/Semaine/Mois -->
  <PeriodPanels
    :content="content"
    :periods="nosPeriods"
    :category="category"
    :current-period="currentPeriod"
    @select="openPeriod"
  />
</section>
